import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface CollectionSummary {
    id: number;
    label: string;
    type: string;
}

export interface TagSummary {
    id: number;
    label: string;
    type: string;
}

export interface LedgerSummary {
    id: number;
    label: string;
    type: string;
    valuesCount: number;
    returnsCount: number;
}

export interface UserEntitiesResponse {
    collections: CollectionSummary[];
    collectionsCount: number;
    tags: TagSummary[];
    tagsCount: number;
    ledgers: LedgerSummary[];
    ledgersCount: number;
}

export function useUserEntities(userId: number | null) {
    return useQuery<UserEntitiesResponse>({
        queryKey: ['admin', 'users', userId, 'entities'],
        queryFn: () => api.get(`/api/admin/users/${userId}/entities`),
        enabled: userId !== null,
    });
}
